/* cyx.js — comportements des sections GemPages clonées (Kelinia · Aceite de Cyperus Rotundus)
   Remplace les scripts GemPages (accordéons, carrousels, vidéo, offre). Chargé une fois. */
(function () {
  if (window.__cyx) return; window.__cyx = true;

  function initAccordions(root) {
    root.querySelectorAll('gp-accordion').forEach(function (acc) {
      if (acc.__cyx) return; acc.__cyx = true;
      var items = Array.prototype.slice.call(acc.querySelectorAll('.gp-accordion-item'));
      var single = acc.getAttribute('data-acc-mode') !== 'multiple';
      var st = {
        bgA: acc.getAttribute('data-acc-bg-active') || '', bgN: acc.getAttribute('data-acc-bg-normal') || '',
        cA: acc.getAttribute('data-acc-c-active') || '',   cN: acc.getAttribute('data-acc-c-normal') || ''
      };
      function setOpen(item, open) {
        var body = item.querySelector('.gp-accordion-item_body');
        var head = item.querySelector('.gp-accordion-item_header');
        var icon = item.querySelector('.gp-collapsible-icon');
        if (body) body.style.gridTemplateRows = open ? '1fr' : '0fr';
        item.classList.toggle('cyx-open', open);
        if (head) {
          if (st.bgA && st.bgA !== 'transparent') head.style.backgroundColor = open ? st.bgA : (st.bgN === 'transparent' ? '' : st.bgN);
          var txt = head.querySelector('.gp-accordion-text-content');
          if (txt && st.cA) txt.style.color = open ? st.cA : st.cN;
        }
        if (icon) icon.style.transform = open ? 'rotate(180deg)' : '';
      }
      items.forEach(function (item, i) {
        var head = item.querySelector('.gp-accordion-item_header');
        setOpen(item, acc.getAttribute('data-acc-open') === 'first' && i === 0);
        if (!head) return;
        head.addEventListener('click', function () {
          var open = !item.classList.contains('cyx-open');
          if (single) items.forEach(function (o) { if (o !== item) setOpen(o, false); });
          setOpen(item, open);
        });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('gp-carousel-v3').forEach(function (car) {
      if (car.__cyx) return; car.__cyx = true;
      var wrap = car.querySelector('.gem-slider-wrapper'); if (!wrap) return;
      var items = Array.prototype.slice.call(wrap.children);
      var dots = car.querySelector('.gp-carousel-dot-container');
      var btns = Array.prototype.slice.call(car.querySelectorAll(':scope > div > div > button'));
      function pageWidth() { return wrap.clientWidth; }
      function pages() {
        if (!items.length) return 1;
        var per = Math.max(1, Math.floor((wrap.clientWidth + 16) / (items[0].getBoundingClientRect().width + 16)));
        return Math.max(1, Math.ceil(items.length / per));
      }
      function renderDots() {
        if (!dots) return;
        dots.innerHTML = '';
        var n = pages();
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'cyx-dot'; b.setAttribute('aria-label', 'Snímek ' + (i + 1));
          (function (i) { b.addEventListener('click', function () { wrap.scrollTo({ left: i * pageWidth(), behavior: 'smooth' }); }); })(i);
          dots.appendChild(b);
        }
        update();
      }
      function update() {
        if (!dots) return;
        var idx = Math.round(wrap.scrollLeft / Math.max(1, pageWidth()));
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', renderDots);
      if (btns.length >= 2) {
        btns[0].addEventListener('click', function () { wrap.scrollBy({ left: -pageWidth(), behavior: 'smooth' }); });
        btns[btns.length - 1].addEventListener('click', function () { wrap.scrollBy({ left: pageWidth(), behavior: 'smooth' }); });
      }
      renderDots();
    });
  }

  function initVideos(root) {
    root.querySelectorAll('.cyx video').forEach(function (v) {
      if (v.__cyx) return; v.__cyx = true;
      if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      v.muted = true; v.loop = true; v.playsInline = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function initOffer(root) {
    root.querySelectorAll('[data-cyx-offer]').forEach(function (offer) {
      if (offer.__cyx) return; offer.__cyx = true;
      var form = offer.closest('form') || document.getElementById('cyx-form');
      var qty = form && form.querySelector('[data-cyx-qty]');
      var deals = Array.prototype.slice.call(offer.querySelectorAll('[data-cyx-deal]'));
      function select(d) {
        deals.forEach(function (o) { o.classList.toggle('is-sel', o === d); });
        if (qty) qty.value = d.getAttribute('data-qty') || '1';
      }
      deals.forEach(function (d) {
        d.addEventListener('click', function () { select(d); });
        d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(d); } });
      });
      var pre = deals.filter(function (d) { return d.classList.contains('is-sel'); })[0];
      if (pre) select(pre);
    });
  }

  function initReviews(root) {
    root.querySelectorAll('[data-cyx-masonry]').forEach(function (grid) {
      if (grid.__cyx) return; grid.__cyx = true;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cyx-review]'));
      function cols() { var w = grid.clientWidth; return w >= 1024 ? 5 : (w >= 640 ? 3 : 2); }
      function layout() {
        var n = cols(); grid.innerHTML = '';
        var columns = []; for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'vtl-pr-masonry__column'; grid.appendChild(c); columns.push(c); }
        cards.forEach(function (card) {
          if (card.hidden) return;
          var best = columns[0]; columns.forEach(function (c) { if (c.offsetHeight < best.offsetHeight) best = c; });
          best.appendChild(card);
        });
      }
      layout();
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layout, 150); });
      var more = grid.closest('.vtl-pr-main-widget') && grid.closest('.vtl-pr-main-widget').querySelector('[data-cyx-more]');
      if (more) more.addEventListener('click', function () { cards.forEach(function (c) { c.hidden = false; }); layout(); more.parentNode.style.display = 'none'; });
      grid.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', function () { /* re-équilibre après chargement */ clearTimeout(t); t = setTimeout(layout, 100); }); });
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-cyx-gallery]').forEach(function (gal) {
      if (gal.__cyx) return; gal.__cyx = true;
      var track = gal.querySelector('[data-cyx-track]'); if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-cyx-slide]'));
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-cyx-thumb]'));
      var dotsBox = gal.querySelector('[data-cyx-dots]'); var dots = [];
      if (dotsBox) slides.forEach(function (_, i) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Obrázek ' + (i + 1)); d.addEventListener('click', function () { go(i); }); dotsBox.appendChild(d); dots.push(d); });
      function w() { return track.clientWidth || 1; }
      function current() { return Math.round(track.scrollLeft / w()); }
      function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * w(), behavior: 'smooth' }); mark(i); }
      function mark(i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); var t = thumbs[i]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = gal.querySelector('[data-cyx-prev]'), next = gal.querySelector('[data-cyx-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(current()); }, 80); }, { passive: true });
      /* glisser à la souris (desktop) */
      var down = false, sx = 0, sl = 0;
      track.addEventListener('mousedown', function (e) { down = true; sx = e.pageX; sl = track.scrollLeft; track.classList.add('is-dragging'); e.preventDefault(); });
      window.addEventListener('mousemove', function (e) { if (down) track.scrollLeft = sl - (e.pageX - sx); });
      window.addEventListener('mouseup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); go(current()); });
      mark(0);
    });
  }

  function init() {
    initGallery(document);
    initAccordions(document); initCarousels(document); initVideos(document); initOffer(document); initReviews(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
